import { useCustomerCompanyList } from "@boundless/bl-api-client/customer/services"
import { createFileRoute } from "@tanstack/react-router"

import { AddCompanyDialog } from "@/components/company/AddCompanyDialog"
import {
  CompanyTable,
  FallbackCompanyTable,
} from "@/components/company/CompanyTable"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { companyListQueryOptions } from "@/lib/companies"

export const Route = createFileRoute("/_dashboard/_customer/companies")({
  component: CompaniesView,
})

function CompanyList() {
  // Same cache key `CompanyWrapper` populates, so this reads the list the
  // dashboard already has rather than issuing a second request. The shared
  // options are mandatory, not a convenience - see `companyListQueryOptions`.
  const { data: companies, isPending } = useCustomerCompanyList(
    {},
    companyListQueryOptions(),
  )

  if (isPending) {
    return <FallbackCompanyTable />
  }

  return <CompanyTable companies={companies ?? []} />
}

function CompaniesView() {
  return (
    <Card>
      <CardHeader className="flex flex-row justify-between">
        <CardTitle>Companies</CardTitle>
        <AddCompanyDialog />
      </CardHeader>
      <CardContent>
        <CompanyList />
      </CardContent>
    </Card>
  )
}
